import { useVendorsApiClient } from 'vendors/api/useVendorsApiClient'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

export const useGetCompanyByBusinessId = (businessId: string, region: string): UseQueryResult<CompanyResponseType> => {
  const { getCompanyByBusinessId } = useVendorsApiClient()

  return useQuery<CompanyResponseType>({
    queryKey: ['company', businessId],
    queryFn: () => getCompanyByBusinessId(businessId, region),
    enabled: !!businessId,
    refetchOnWindowFocus: false
  })
}
